const OPERATORS_STATISTICS = {
  OPERATORS_STATISTICS_HEADER_TITLE: 'Statistics of operators',
  OPERATORS_STATISTICS_HEADER_SUB_TITLE: `You can check the total and average activity time statistics accepted calls and the details of each operator's statistics by choosing the time frame you want.`,
  OPERATORS_STATISTICS_MAIN_TITLE: 'Statistics of operators',
  OPERATORS_STATISTICS_TABLE_OPERATOR_COL_LABEL: 'Operator',
  OPERATORS_STATISTICS_TABLE_TOTAL_ACTIVE_COL_LABEL: 'Total active time',
  OPERATORS_STATISTICS_TABLE_AVG_ACTIVE_COL_LABEL: 'Average active time',
  OPERATORS_STATISTICS_TABLE_ACCEPTED_CONVS_LABEL: 'Accepted convs',
  OPERATORS_STATISTICS_TABLE_AVG_ANS_LABEL: 'Avg response time',
  OPERATORS_STATISTICS_TABLE_AVG_CLOSE_LABEL: 'Avg close time',
  OPERATORS_STATISTICS_TABLE_CUSTOMER_SATISFACTION_LABEL:
    'Customer satisfaction (%)',
  OPERATORS_STATISTICS_TABLE_ACCEPTED_COL_PREFIX: 'convs',
  OPERATORS_STATISTICS_TABLE_SCORE_LABEL: 'Score (100)',
  OPERATORS_STATISTICS_TABLE_DETAILS_LABEL: 'Details',
  OPERATORS_STATISTICS_NO_OPERATOR_TO_DISPLAY:
    'There is no operator to display',
  OPERATORS_STATISTICS_AVERAGE_ITEM_LABEL: 'Average',
  OPERATORS_STATISTICS_CSV_EXPORT_BTN_LABEL: 'CSV EXPORT',
  OPERATORS_STATISTICS_CSV_EXPORT_FILE_PREFIX: 'operators_report',
  CSV_EXPORT_ACCESS_MSG:
    'To use this feature please upgrade your package to premium',
  SCORE_ITEM_PREFIX: 'out of 100',
};

export default OPERATORS_STATISTICS;
